import TrendingBlock from './TrendingBlock'

export default TrendingBlock
